import questionnaireCompliance from "./questionnaireCompliance";
import questionnaireAppLevy from "./questionnaireAppLevy";
import questionnaireLoans from "./questionnaireLoans";
import questionnaireCJRS from "./questionnaireCJRS";
import questionnairePSA from "./questionnairePSA";
import questionnaireOpwPart1 from "./questionnaireOpwPart1";
import questionnaireOpwPart2 from "./questionnaireOpwPart2";
import questionnaireOpwPart3 from "./questionnaireOpwPart3";
import questionnaireCIS from "./questionnaireCIS";
import questionnaireBenefits from "./questionnaireBenefits";
import questionnaireExpenses from "./questionnaireExpenses";
import questionnaireTP from "./questionnaireTP";
import questionnaireNMW from "./questionnaireNMW";
import questionnaireNRD from "./questionnaireNRD";
import questionnairePayroll from "./questionnairePayroll";
import questionnaireGM from "./questionnaireGM";
import questionnaireFollowUp from "./questionnaireFollowUp";

export const v1SurveySchema= {
    version: "1.0",
    findingAreas: [
        questionnaireCompliance,
        questionnaireAppLevy,
        questionnairePSA,
        questionnaireLoans,
        questionnaireCJRS,
        questionnaireOpwPart1,
        questionnaireOpwPart2,
        questionnaireOpwPart3,
        questionnaireCIS,
        questionnaireBenefits,
        questionnaireExpenses,
        questionnaireTP,
        questionnaireNMW,
        questionnaireNRD,
        questionnairePayroll,
        questionnaireGM,
        questionnaireFollowUp
    ],
};
